require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./illegal-drug-markets.json") })
        }
      }, "path---illegal-drug-markets");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---illegal-drug-markets!./.cache/json/illegal-drug-markets.json
// module id = 904
// module chunks = 231608221292675